import { render, staticRenderFns } from "./nutritionSaleForm.vue?vue&type=template&id=3805b03f&scoped=true"
import script from "./nutritionSaleForm.vue?vue&type=script&lang=js"
export * from "./nutritionSaleForm.vue?vue&type=script&lang=js"
import style0 from "./nutritionSaleForm.vue?vue&type=style&index=0&id=3805b03f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805b03f",
  null
  
)

export default component.exports